import axios, { AxiosInstance } from "axios";
import {
  EhrAuthPath,
  athenaHealthAuthPath,
  canvasAuthPath,
  eclinicalworksAuthPath,
  elationAuthPath,
  healthieAuthPath,
  salesforceAuthPath,
  practicefusionAuthPath,
  embedAuthPath,
  ParsedPageAuthPath,
} from "../domain/ehr";
import { isDevEnv } from "../shared/util";

export function getBaseURL(EhrName?: string): string {
  if (EhrName) return process.env[`REACT_APP_${EhrName}_API_URL`]!; // eslint-disable-line @typescript-eslint/no-non-null-assertion
  return process.env.REACT_APP_API_URL!; // eslint-disable-line @typescript-eslint/no-non-null-assertion
}

let apiOssProxy: AxiosInstance | null;
export const ossBaseUrlAthena = `${getBaseURL()}/${isDevEnv() ? "athenahealth" : "athena"}`;
export const ossBaseUrlCanvas = `${getBaseURL()}/canvas`;
export const ossBaseUrlElation = `${getBaseURL()}/elation`;
export const ossBaseUrlHealthie = `${getBaseURL()}/healthie`;
export const ossBaseUrlEClinicalWorks = `${getBaseURL()}/eclinicalworks`;
export const ossBaseUrlSalesforce = `${getBaseURL()}/salesforce`;
export const ossBaseUrlPracticeFusion = `${getBaseURL("PRACTICEFUSION")}/practicefusion`;
export function setAuthTokenHeaders(token: string, ehrAuthPath: EhrAuthPath) {
  if (ehrAuthPath.authPath === athenaHealthAuthPath) {
    apiOssProxy = axios.create({ baseURL: ossBaseUrlAthena });
  } else if (ehrAuthPath.authPath === canvasAuthPath) {
    apiOssProxy = axios.create({ baseURL: ossBaseUrlCanvas });
  } else if (ehrAuthPath.authPath === elationAuthPath) {
    apiOssProxy = axios.create({ baseURL: ossBaseUrlElation });
  } else if (ehrAuthPath.authPath === healthieAuthPath) {
    apiOssProxy = axios.create({ baseURL: ossBaseUrlHealthie });
  } else if (ehrAuthPath.authPath === eclinicalworksAuthPath) {
    apiOssProxy = axios.create({ baseURL: ossBaseUrlEClinicalWorks });
  } else if (ehrAuthPath.authPath === salesforceAuthPath) {
    apiOssProxy = axios.create({ baseURL: ossBaseUrlSalesforce });
  } else if (ehrAuthPath.authPath === practicefusionAuthPath) {
    apiOssProxy = axios.create({ baseURL: ossBaseUrlPracticeFusion });
  } else {
    throw new Error("Invalid EHR auth path");
  }
  apiOssProxy.defaults.headers.common["Authorization"] = token;
}

export const ossBaseUrlEmbedPage = `${getBaseURL()}/embed`;
export function setAuthTokenHeadersForPage(token: string, pageAuthPath: ParsedPageAuthPath) {
  if (pageAuthPath.basePath === embedAuthPath) {
    apiOssProxy = axios.create({ baseURL: ossBaseUrlEmbedPage });
  } else {
    throw new Error("Invalid Page auth path");
  }
  apiOssProxy.defaults.headers.common["Authorization"] = token;
}

export function getOssProxyOrFail(): AxiosInstance {
  if (!apiOssProxy) throw new Error("Oss proxy not initialized");
  return apiOssProxy;
}
